<div class="add-container">
    <h1 class="add-title">Adaugă</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field appearance="fill">
                    <mat-label>Email</mat-label>
                    <input type="text" matInput formControlName="email">
                    <mat-error *ngIf="form.controls['email'].hasError('required') && form.controls['email'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-error *ngIf="form.controls['email'].hasError('pattern') && form.controls['email'].touched">
                        Email nevalid
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field appearance="fill">
                    <mat-label>Procesare</mat-label>
                    <mat-select formControlName="process">
                        <mat-option *ngFor="let option of statusOptions"
                            [value]="option.id">{{option.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['process'].valid && form.controls['process'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field appearance="fill">
                    <mat-label>Confirmare</mat-label>
                    <mat-select formControlName="confirmation">
                        <mat-option *ngFor="let option of statusOptions"
                            [value]="option.id">{{option.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['confirmation'].valid && form.controls['confirmation'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>